class $WebSocket {
  // 构造函数
  constructor() {
    // 连接状态 0表示正在连接 1表示连接成功，可以通信了2表示连接正在关闭3表示连接已经关闭，或者打开连接失败
    this.connecting = 3
    // 默认连接路径。发起连接请求时未传连接路径将使用此路径
    this.defaultPath = 'ws://82.157.123.54:9010/ajaxchattest'
    // SOCKET对象
    this.socket = null
  }

  showToast(title) {
    uni.showToast({
      title: title,
      icon: 'none',
      duration: 2000
    })
  }

  // 发起连接
  connect(url = this.defaultPath) {
    this.connecting = 0
    // 实例化socket
    this.socket = new WebSocket(url)

    // 监听socket连接
    this.socket.onopen = this.onOpen
    // 监听socket关闭
    this.socket.onclose = this.onClose
    // 监听socket错误信息
    this.socket.onerror = this.onError
    // 监听socket消息
    this.socket.onmessage = this.onMessage
    console.log('连接结果。。。。。。。。。。。。。。。。。。。。', this.socket)
  }
  // 监听连接成功
  onOpen() {
    this.connecting = 1
    console.log('socket连接成功', this.connecting)
  }
  // 监听连接关闭
  onClose(p) {
    console.log('监听连接关闭', p)
    this.connecting = 3
  }
  // 监听错误
  onError(e) {
    console.log('监听到的错误', e)
  }
  // 监听收到的服务器消息
  onMessage(msg) {
    console.log('websocket接到服务器的消息', msg.data)
  }

  // 向服务发送消息
  send(params) {
    console.log('websocket发送消息', params)
    if (this.connecting == 1) {
      this.socket.send(params)
    } else {
    }
  }
  // 关闭连接
  close() {
    this.connecting = 2
    this.socket.close()
    console.log('socket已经关闭')
  }
}
import Vue from 'vue'
Vue.prototype.$WS = new $WebSocket()



// WEBPACK FOOTER //
// ./src/request/webscoket.js